<template>
  <div class="app-layout">
    <div class="app-layout__wrapper">
      <div class="app-container">

        <div class="auth-container">
          <div class="auth-loader" v-if="isAuthPending">
            <b-spinner label="Authentication..." />
            <div class="auth-loader__label">Authentication...</div>
          </div>

          <div class="auth-error" v-if="authError">
            {{ authError }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',

  computed: {
    isLoggedIn () {
      return this.$store.getters['auth/isLoggedIn'];
    },

    isAuthPending () {
      return this.$store.getters['auth/isAuthPending'];
    },

    authError () {
      return this.$store.getters['auth/authError'];
    }
  },

  mounted () {
    console.log(this.$router);
    this.auth().then(() => {
      // eslint-disable-next-line no-underscore-dangle
      if (this.$router.history._startLocation.includes('patchId')) {
        // eslint-disable-next-line no-underscore-dangle
        console.log(this.$router.history._startLocation);
        this.$router.push({ path: '/patchEditor', query: this.$route.query });
        // eslint-disable-next-line no-underscore-dangle
      } else if (this.$router.history._startLocation.includes('insertId')) {
        this.$router.push({ path: '/insertEditor', query: this.$route.query });
      } else {
        this.$router.push({ path: '/', query: this.$route.query });
      }
    });
  },
  /* // eslint-disable-next-line no-underscore-dangle
      if (this.$router.history._startLocation.includes('insertId')) {
        this.$router.push({ path: '/insertEditor', query: this.$route.query });
        } */

  methods: {
    auth () {
      return this.$store.dispatch('auth/getToken');
    },
  }
};
</script>

<style scoped>
  .app-container {
    height: 700px;
    padding: 15px;
    position: relative;
  }

  .auth-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .auth-loader {
    text-align: center;
  }

  .auth-loader__label {
    padding-top: 10px;
  }
</style>
